import {Component} from "@angular/core";
import {OrganisationValidator} from "../interpreter-signup/organisation.validator";
import {FormGroup} from "@angular/forms";
import {Organisation} from "../../job/shared/organisation.model";
import {User} from "../../shared/user/user.model";
import {AppAuth} from "../../../app/core/auth";
import {JobsPage} from "../../jobs/jobs.page";
import {Events, ModalController, NavController} from "ionic-angular";
import {CountryCodesService} from "../../shared/country-codes.service";
import {LoginPage} from "../../login/login.page";
import {OrganisationSearchModal} from "../../../app/components/organisation-search-modal/organisation-search-modal.component";

@Component({
  selector: 'app-client-signup',
  templateUrl: 'client-signup.component.html',
  providers: [OrganisationValidator],

})
export class ClientSignupComponent {
  form: FormGroup;
  user: User = new User();
  invoiceEmailIsPersonalEmail: boolean = true;

  constructor(private organisationValidator: OrganisationValidator,
              private auth: AppAuth,
              private nav: NavController,
              private modalCtrl: ModalController,
              private events: Events,
              public countryCodesService: CountryCodesService) {
    this.user.organisation = new Organisation();

    this.form = this.organisationValidator.init(this.user, 'create');
  }

  ngOnInit(): any {
    this.events.subscribe('organisation:selected', (query) => this.setOrganisation(query));
  }

  ngOnDestroy() {
    this.events.unsubscribe('organisation:selected');
  }

  openOrganisationsSearchModal() {
    let modal = this.modalCtrl.create(OrganisationSearchModal);
    modal.present();
  }

  invoiceEmailToggled() {
    if (this.invoiceEmailIsPersonalEmail) {
      this.user.organisation.invoice_email = null;
    }
  }

  signup() {
    this.auth.signup(this.user, 'organisation')
      .subscribe(success => this.nav.setPages([{page: JobsPage}]));
  }

  setOrganisation(query) {
    console.log(query);

    // If object selected from list manually, then just assign it
    if (query !== null && typeof query === 'object') {
      this.setUserOrganisation(query);
      return;
    }

    // Otherwise set the name of the organisation only
    this.user.organisation.name = query;
    this.user.organisation.id = null;
  }

  setUserOrganisation(organisation) {
    this.user.organisation = organisation;
    this.invoiceEmailIsPersonalEmail = !organisation.invoice_email;
  }

  goToLoginPage() {
    this.nav.push(LoginPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/signup/client-signup/client-signup.component.ts